import React from 'react'
import Products from './Products'
import Preview from './Preview'
import {i} from '../../i'

export default class Hero extends React.Component {
  state={}
  render() {
    return (
      <section className="hero text-center">
        <div className="container-sm">
          <div className="hero-inner">
            <h1 className="hero-title h2-mobile mt-0 is-revealing">{i.name}</h1>
            <p className="hero-paragraph is-revealing">{i.description}</p>

            <Products />

            <Preview />
          </div>
        </div>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/component/section/Hero.js